import { Numeric } from "@salaxy/core";
/**
 * Rounds provided value
 * @param value Numeric value to round
 * @param options Options for decimals and nullChar
 * @returns Rounded provided value
 */
export function hbsHelperR(value: number, options: any): string {
  const params = options && options.hash ? options.hash : options;
  return value ? (params && ( params.dec || params.dec === 0 || params.dec === null)) ? Numeric.formatNumber(value, params.dec) : Numeric.formatNumber(value) : ((params && params.nullChar) ? params.nullChar : "-");
}